/**
 * Self-serve Telegram-bot provisioning API client.
 *
 * Mirrors the three endpoints under ``/integrations/telegram`` on the
 * backend. ``status`` always returns 200 — ``active=false`` for orgs
 * that haven't set anything up — so the Settings card has a single
 * source of truth for both states.
 */
import client from "./client";

export interface TelegramBotStatus {
  active: boolean;
  bot_username: string | null;
  bot_link: string | null;
  telegram_bot_id: number | null;
  created_at: string | null;
}

export async function getTelegramStatus(): Promise<TelegramBotStatus> {
  const res = await client.get<TelegramBotStatus>("/integrations/telegram/status");
  return res.data;
}

export async function setupTelegramBot(
  botToken: string
): Promise<TelegramBotStatus> {
  const res = await client.post<TelegramBotStatus>(
    "/integrations/telegram/setup",
    { bot_token: botToken }
  );
  return res.data;
}

export async function disconnectTelegramBot(): Promise<TelegramBotStatus> {
  const res = await client.delete<TelegramBotStatus>(
    "/integrations/telegram/disconnect"
  );
  return res.data;
}
